import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IdentityCode } from '../identity/code/index';
import IdentityationIlustration from './../../assets/images/placeholder/confirmation-ilustration.svg';
import * as R from 'ramda';
import { useHistory, useLocation } from 'react-router';
import JwtDecode from 'jwt-decode';

export const Code = () => {
    const auth = useSelector(state => state.auth);
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (!R.isNil(auth.loggedIn) && auth.loggedIn === true) {

            const returnUrl = new URLSearchParams(location.search).get("returnUrl");
            if (!R.isNil(returnUrl)) {
                window.location = returnUrl;
                return;
            }

            let accessToken = sessionStorage.getItem("access_token");
            if (!R.isNil(accessToken)) {
                let decodedJwt = JwtDecode(accessToken);
                let rolesFromToken = decodedJwt["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
                if (!R.isNil(rolesFromToken)) {
                    let roles = Array.isArray(rolesFromToken) ? rolesFromToken : [rolesFromToken];
                    if (roles.includes("DISTRIBUTER") || (roles.includes("ADMIN") && roles.length === 1)) {
                        window.location = "/backoffice";
                        return;
                    } else if (roles.includes("REPRESENTATIVE")) {
                        window.location = "/facilita";
                        return;
                    }
                    else {
                        window.location = `/anticipa${location.search}`;
                        return;
                    }
                }
            }
            // if(auth.roles.include("USER")){
            //     history.push("/anticipa");
            // }else if(auth.roles.include("REPRESENTATIVE")){
            //     history.push("/facilita");
            // }


        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.loggedIn]);

    return (
        <main role="main" className="view flex-grow-1 pb-sm pb-xl-gutter" style={{ minHeight: "500px" }}>
            <div className="container-fluid container-modal m-auto h-inherit">
                <section className="card card-body card-lg rounded-top-left-xl rounded-bottom-right-xl h-inherit shadow" >
                    <h4 className="sr-only visually-hidden">Registratio Compte</h4>
                    <div className="row justify-content-row gx-2 h-inherit">
                        <div className="col-12 col-lg h-inherit">
                            <img className="img-fluid img-contain container-md-wide mx-auto mt-4 my-lg-auto h-inherit" width="480" src={IdentityationIlustration} alt="Assist@" />
                        </div>
                        <IdentityCode loginPage={true} />
                    </div>
                </section>
            </div>
        </main>
    );
};